import React, { useContext } from 'react';
import { AuthContext } from 'components/user/AuthContext';
import Action from './Action';

const Reply = ({ repliesCount, onReply }) => {
    const { isLoggedIn } = useContext(AuthContext);

    const handleReply = () => {
        if (isLoggedIn) {
            onReply();
        }
    };

    return (
        <Action
            count={repliesCount}
            onClick={handleReply}
            disabled={!isLoggedIn}
            ariaLabel="Reply to twut"
            tooltipPrefix="Total Replies: "
            buttonClassName={`text-gray-more ${isLoggedIn ? 'hover:text-blue-mid cursor-pointer' : 'cursor-default'}`}
            iconClassName={'fa-regular fa-comment scale-x-[-1]'}
        />
    );
};

export default Reply;
